import AppContext from './AppContext';
import { Role } from 'app/model/CORE';
import Utils from 'app/common/util/Utils';

export default class AuthorisationUtils {
    private static getUnitRoles() {
        return AppContext.configData?.userProfile?.unitRoleList;
    }

    static getUserRoles(): Array<Role> {
        return this.getUnitRoles()?.map(o => o.role);
    }

    static isFmpUser(): boolean {
        return this.getUserRoles()?.includes(Role.FMP);
    }

    static isNmUser(): boolean {
        return Utils.isEmpty(this.getUserRoles()) || this.getUserRoles().includes(Role.NM);
    }

    static getFmpUnit(): string {
        return `FMP${this.getUnitRoles()?.map(u => u.opUnit)[0]}`;
    }

    static isFmpMapUser(): boolean {
        return this.getUserRoles()?.includes(Role.FMP_MAP);
    }
}
